const ua = window.navigator.userAgent
const reg = /Firefox|Edge|Trident|QQBrowser|QIHU|360EE|360SE|Maxthon|2345Explorer|opera/i
const isOther = reg.test(ua)
const chromeReg = /chrome\/?\s*([\d.]+)/i // chrome 浏览器 win端 或者 mac 端
const isChrome = chromeReg.test(ua)
const chromeVer = RegExp.$1
const sv = 68
const lower = parseInt(chromeVer, 10) < sv
// 优先级
// maxTouchPoints 判断是否是触控屏
// 是触控屏，再判断关键字 ipad 或者 Macintosh 即可判断是ipad
// 是ipad的情况下
// 1、ipad 端 chrome 浏览器 特征：关键字 CriOS；CriOS 后接版本号 CriOS/87.0.4280.77
// 2、ipad 端 safari 浏览器 特征：关键字 Version；Version 后接版本号 Version/14.0.2
// (ipad 不能作为safari判断条件，ipad air 没有该关键字 )
const { maxTouchPoints } = window.navigator

const regIpad = /Macintosh/i // ipad 或者 mac
const isIpad = /iPad|iphone/i.test(ua) || (maxTouchPoints > 0 && regIpad.test(ua)) // 可判断是否是ipad
const regAndroid = /Android|Linux/i
const isAndroid = regAndroid.test(ua)

const isPad = isIpad || isAndroid

const svIpad = 11 // ipad 端 safari 最小版本号
const regIpadSafari = /Version\/?\s*([\d.]+)/i
const isIpadSafari = isIpad && regIpadSafari.test(ua) // 可判断是否是ipad端 safari
const ipadSafariVer = RegExp.$1 // safari 版本号
const lowerIpadSafari = parseInt(ipadSafariVer, 10) < svIpad

const regIpadChrome = /CriOS\/?\s*([\d.]+)/i
const isIpadChrome = isIpad && regIpadChrome.test(ua) // 可判断是否是ipad端 chrome
const ipadChromeVer = RegExp.$1
const lowerIpadChrome = parseInt(ipadChromeVer, 10) < sv

const regXesPad = /xuersi\/?\s*([\d.]+)/i
const xesPad = regXesPad.test(ua)
const xesPadVer = RegExp.$1
const isXesPad =
  xesPad && xesPadVer && parseInt(xesPadVer.replace(/\./gi, '').slice(0, 3), 10) < 531

const regXES = /XES/i
const isInXES = regXES.test(ua)
const isInXESPad = isInXES && isPad
const isInPc = /小猴编程/.test(navigator.userAgent)

const getQueryStringArgs = (str = '') => {
  const qs = str.length > 0 ? str.substring(1) : '';
  const args = {};

  const items = qs.length ? qs.split('&') : [];

  for (let i = 0, len = items.length; i < len; i += 1) {
    const item = items[i].split('=');
    const name = decodeURIComponent(item[0]);
    const value = decodeURIComponent(item[1]);

    if (name.length) args[name] = value;
  }

  return args;
};
let { fr: xesfr = 'ts' } = getQueryStringArgs(window.location.search);
if (!xesfr && window.qiankunData) {
  xesfr = window.qiankunData.fr
}
if (isPad && isInXES) {
  if (!/noRelogin/.test(window.location.hash)) {
    localStorage.removeItem('XIAOHOUCODE_USERINFO');
  }
}
const sessionInfo = JSON.parse(sessionStorage.getItem('XIAOHOUCODE_SESSION_INFO')) || {};

const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
const fr = sessionInfo.fr || urlParams.get('fr') || xesfr;
export {
  isIpad,
  isPad,
  isOther,
  lower,
  isChrome,
  isIpadSafari,
  isIpadChrome,
  lowerIpadSafari,
  lowerIpadChrome,
  isXesPad,
  xesPad,
  isInXES,
  isInXESPad,
  isAndroid,
  isInPc,
  fr,
};
